module.exports = __webpack_public_path__ + "img/picture.07526c9d.jpg";